import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import useStyles from './BlogAuthorCard.styles';
import { useBackgroundClass } from '../../styles/jss/utils';
import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';
import { Box, useTheme } from '@mui/material';
import RichText from '../RichText/RichText';
import { READ_MORE, READ_LESS } from '../../utils/constants';
import { useLoaded } from '../MainContent/useComponentLoading';
const iconMap = {
    facebook: '/images/icons/socialLinks/facebook.svg',
    instagram: '/images/icons/socialLinks/instagram.svg',
    x: '/images/icons/socialLinks/x.svg',
    tiktok: '/images/icons/socialLinks/tiktok.svg',
};
const bioBottomMargin = 16;
const BlogAuthorCard = (props) => {
    const { name, image, backgroundColor, expertiseDescription, bioDescription, authorSocialLinks } = props;
    const { classes } = useStyles();
    const imgUrl = image === null || image === void 0 ? void 0 : image.url;
    const { bgClass } = useBackgroundClass(backgroundColor);
    const theme = useTheme();
    const isMobileDevice = !useMediaQuery({ query: `(min-width: ${theme.breakpoints.values.sm}px)` });
    const renderImage = () => _jsx("img", { className: classes.image, src: imgUrl, alt: image === null || image === void 0 ? void 0 : image.altText });
    const getSocialLinkIcon = (url, icon) => {
        var _a, _b;
        return (_b = (_a = Object.entries(iconMap).find(([key]) => (icon === null || icon === void 0 ? void 0 : icon.toLowerCase().includes(key)) || (url === null || url === void 0 ? void 0 : url.toLowerCase().includes(key)))) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '';
    };
    const [isBioExpanded, setIsBioExpanded] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false);
    const bioRef = useRef(null);
    const maxLines = isMobileDevice ? 4 : 2;
    const lineHeight = parseFloat(`${theme.typography.small_regular.lineHeight}`);
    const maxHeight = maxLines * lineHeight * 16;
    useEffect(() => {
        const calculateTruncation = () => {
            if (bioRef.current) {
                const bioHeight = bioRef.current.scrollHeight;
                setIsTruncated(bioHeight > maxHeight + bioBottomMargin);
            }
        };
        calculateTruncation();
        window.addEventListener('resize', calculateTruncation); // Recalculate on resize
        return () => {
            window.removeEventListener('resize', calculateTruncation); // Cleanup listener
        };
    }, [bioDescription, maxHeight]);
    const toggleBio = () => {
        setIsBioExpanded((prev) => !prev);
    };
    const getTruncatedBio = () => {
        return (_jsx(Box, { ref: bioRef, className: classes.bio, sx: {
                maxHeight: isBioExpanded ? 'none' : `${maxHeight}px`,
                overflow: isBioExpanded ? 'visible' : 'hidden',
            }, children: _jsx(RichText, { content: bioDescription }) }));
    };
    useLoaded(props);
    return (_jsxs("div", { className: clsx(bgClass, classes.blogAuthorCard), children: [!isMobileDevice && renderImage(), _jsxs("div", { children: [_jsxs(Box, { className: classes.titleContainer, children: [isMobileDevice && renderImage(), _jsxs("div", { className: isMobileDevice ? classes.nameAndExpertiseContainer : '', children: [_jsx("div", { className: classes.name, children: name }), expertiseDescription && (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.pipeSymbol, children: "|" }), _jsx("div", { className: classes.expertise, children: expertiseDescription })] }))] })] }), bioDescription && getTruncatedBio(), bioDescription && isTruncated && (_jsx(Box, { className: classes.readMoreButton, onClick: toggleBio, children: isBioExpanded ? READ_LESS : READ_MORE })), (authorSocialLinks === null || authorSocialLinks === void 0 ? void 0 : authorSocialLinks.length) && (_jsx("div", { className: classes.socialLinksContainer, children: authorSocialLinks.map((link) => (link === null || link === void 0 ? void 0 : link.url) && (_jsx("a", { href: link === null || link === void 0 ? void 0 : link.url, className: classes.authorSocialLink, target: "_blank", children: _jsx(Box, { component: "img", src: getSocialLinkIcon(link === null || link === void 0 ? void 0 : link.url, link === null || link === void 0 ? void 0 : link.icon), alt: `Link Icon`, className: classes.socialIcon }) }, link === null || link === void 0 ? void 0 : link.url))) }))] })] }));
};
export default BlogAuthorCard;
